module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00693.a8948893.jpg";